<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  mounted() {
    if (this.$route.name == "CollaboratorBonusAndPromotions") {
      this.mainTab();
    }
  },
  watch: {
    $route(val) {
      if (val.name == "CollaboratorBonusAndPromotions") {
        this.mainTab();
      }
    },
  },

  computed: {
    canListBonus() {
      return this.$permission("8");
    },
    canListPromotions() {
      return this.$permission("4");
    },
  },

  methods: {
    mainTab() {
      let name = "";

      if (this.canListPromotions) {
        name = "CollaboratorListPromotionOnline";
      } else if (this.canListBonus) {
        name = "CollaboratorListBonusOnline";
      }

      this.$router.push({
        name,
      });
    },
  },
};
</script>
